<ion-header [translucent]="true">
    <ion-toolbar *ngIf="mode === 'manage'">
        <ion-title>Sessions</ion-title>
        <ion-buttons slot="primary">
            <ion-button (click)="importSession()">
                <ion-icon name="add-outline"></ion-icon>
            </ion-button>
        </ion-buttons>

        <ion-buttons slot="secondary">
            <ion-button (click)="openActionMenu($event)">
                <ion-icon name="ellipsis-vertical-outline"></ion-icon>
            </ion-button>

            <app-pwa-prompt></app-pwa-prompt>
        </ion-buttons>
    </ion-toolbar>

    <ion-toolbar *ngIf="mode !== 'manage'">
        <ion-title *ngIf="mode === 'select-for-export'">Export</ion-title>
        <ion-title *ngIf="mode === 'select-for-delete'">Delete</ion-title>

        <ion-buttons slot="primary">
            <ion-button (click)="onSelectionDone()">{{
                selection.size === 0 ? 'Cancel' : mode === 'select-for-export' ? 'Export' : 'Delete'
            }}</ion-button>
        </ion-buttons>

        <ion-buttons slot="secondary" *ngIf="selection.size !== sessionCount">
            <ion-button (click)="onSelectAll()">Select all</ion-button>
        </ion-buttons>

        <ion-buttons slot="secondary" *ngIf="selection.size === sessionCount">
            <ion-button (click)="selection.clear()">Clear</ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content (contextmenu)="onContextMenu($event)" [fullscreen]="true">
    <ion-header collapse="condense">
        <ion-toolbar>
            <ion-title size="large" *ngIf="mode === 'manage'">Sessions</ion-title>
            <ion-title size="large" *ngIf="mode === 'select-for-export'">Select for export</ion-title>
            <ion-title size="large" *ngIf="mode === 'select-for-delete'">Select for delete</ion-title>
        </ion-toolbar>
    </ion-header>

    <div class="loader" *ngIf="sessionService.loading()">
        <ion-spinner></ion-spinner>
    </div>

    <div *ngIf="!sessionService.loading() && sessionCount === 0" class="placeholder-container">
        <div class="placeholder">
            No sessions. Select the &bdquo;+&ldquo; icon in the upper right corner in order to import a ROM file or a
            session image.
            <ng-container *ngIf="showPalmdbLink">
                <br /><br />
                You can find a collection of compatible ROMs on
                <a href="https://palmdb.net/app/palm-roms-complete" target="_blank" rel="external">PalmDB</a>.
            </ng-container>
            <ng-container *ngIf="!showPalmdbLink">
                <br /><br />
                Please check <a href="#/tab/about">"About"</a> for a comprehensive list of supported devices running
                PalmOS up to version 5.x.
            </ng-container>
        </div>
    </div>

    <ion-list *ngIf="!sessionService.loading() && sessionCount > 0">
        <app-session-item
            *ngFor="let session of sessions; trackBy: trackSessionBy"
            [session]="session"
            (delete)="deleteSession(session)"
            (selectItem)="mode === 'manage' ? launchSession(session) : toggleSelection(session)"
            (edit)="editSession(session)"
            (save)="saveSession(session)"
            (resetSession)="resetSession(session)"
            (interaction)="lastSessionTouched = session.id"
            [selected]="currentSessionId() === session.id"
            [touched]="session.id === lastSessionTouched"
            [selecting]="mode !== 'manage'"
            [selectedForExport]="selection.has(session.id)"
        >
        </app-session-item>
    </ion-list>
</ion-content>
